export default __webpack_public_path__ + "static/media/flight5.7cc6d4a1.jpg";